import { z } from "zod";
import type {
    PayRequestPaymentEvent} from "./_pay-request-payment.event";
import {
    payRequestPaymentEventZodObjects,
} from "./_pay-request-payment.event";
import type {
    PayRequestCancelledEvent} from "./pay-request.cancelled.event";
import {
    payRequestCancelledEventZodObject,
} from "./pay-request.cancelled.event";
import type {
    PayRequestCreatedEvent} from "./pay-request.created.event";
import {
    payRequestCreatedEventZodObject,
} from "./pay-request.created.event";

type PayRequestEvent =
    | PayRequestCancelledEvent
    | PayRequestCreatedEvent
    | PayRequestPaymentEvent;

const payRequestEventZodUnion = z.union([
    payRequestCancelledEventZodObject,
    payRequestCreatedEventZodObject,
    ...payRequestPaymentEventZodObjects,
]);
const payRequestEventZodSchema: z.ZodSchema<PayRequestEvent> =
    payRequestEventZodUnion;

export { payRequestEventZodSchema };
export type { PayRequestEvent };
